module.exports = __webpack_public_path__ + "static/media/card-profile1.a0949f48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/card-profile1.jpg
// module id = 320
// module chunks = 0